"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _RadialProgressBar = _interopRequireDefault(require("../RadialProgressBar"));

var _ResultHeader = _interopRequireDefault(require("./ResultHeader"));

var _ResultInfo = _interopRequireDefault(require("./ResultInfo"));

var _ResultSection = _interopRequireDefault(require("./ResultSection"));

var RadialResultSection =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RadialResultSection, _React$Component);

  function RadialResultSection() {
    (0, _classCallCheck2.default)(this, RadialResultSection);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadialResultSection).apply(this, arguments));
  }

  (0, _createClass2.default)(RadialResultSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          displayValueUnit = _this$props.displayValueUnit,
          displayValue = _this$props.displayValue,
          radialContainerClass = _this$props.radialContainerClass,
          score = _this$props.score,
          progressBarIcon = _this$props.progressBarIcon,
          gradeType = _this$props.gradeType;
      return _react.default.createElement(_ResultSection.default, {
        gradeType: gradeType
      }, _react.default.createElement(_ResultHeader.default, this.props), _react.default.createElement("div", {
        className: radialContainerClass
      }, _react.default.createElement(_RadialProgressBar.default, {
        score: score
      }, _react.default.createElement("div", {
        className: "icon " + progressBarIcon
      })), _react.default.createElement("div", {
        className: "result-value"
      }, displayValue, _react.default.createElement("span", {
        className: "result-value-unit"
      }, displayValueUnit))), _react.default.createElement(_ResultInfo.default, this.props));
    }
  }]);
  return RadialResultSection;
}(_react.default.Component);

exports.default = RadialResultSection;
RadialResultSection.propTypes = {
  gradeType: _propTypes.default.string,
  resultGrade: _propTypes.default.number,
  resultValueUnit: _propTypes.default.string,
  score: _propTypes.default.number,
  displayValueUnit: _propTypes.default.string,
  displayValue: _propTypes.default.number,
  radialContainerClass: _propTypes.default.object,
  progressBarIcon: _propTypes.default.string
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/RadialResultSection.js
// module id = 298
// module chunks = 0